var paragraph_default = {
  "fontElementMap": "H6r4E",
  "elementSpacing": "fvFfv",
  "text": "fxTZ7 fvFfv",
  "child": "zzOoR"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
